

import React from 'react';
import './Clasament.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import StatsCard from '../popupsright/StatsCard';
import MotivationalClasament from '../rightelements/MotivationalClasament';
import GetProCard from '../rightelements/GetProCard';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import './reglaredimensiune.css';

const mockUsers = [
  { id: 1, name: 'User1', xp: 0, blurred: true },
  { id: 2, name: 'User2', xp: 0, blurred: true },
  { id: 3, name: 'User3', xp: 0, blurred: true },
  { id: 4, name: 'User4', xp: 0, blurred: true },
  { id: 5, name: 'alindorobantu95', xp: 0, blurred: false },
];

export default function Clasament() {
  return (

    <div className="componentsmenu-container-main"> 
      <div className="componentsmenu-left-blank"></div>
      <div className="componentsmenu-container">
          <StatsCard />
        
        <div className="leaderboard-list">
          <div className="certificate-title-custom">Clasament</div>
          <div className="leaderboard-message">
            Castiga 100 XP pentru a intra in clasament
          </div>
          {mockUsers.map((user, idx) => (
            <div key={user.id} className={`leaderboard-user${!user.blurred ? ' current' : ''}`} style={{marginBottom: idx === mockUsers.length - 1 ? 0 : undefined}}>
              <span className="leaderboard-rank">{user.blurred ? '' : '-'}</span>
              <div className={`leaderboard-avatar${!user.blurred ? ' current' : ''}`}>
                {user.blurred ? '' : <FontAwesomeIcon icon={faUser} className="leaderboard-usericon" />}
              </div>
              <div className={`leaderboard-name${!user.blurred ? ' current' : ''}`}>
                {user.blurred ? <div className="leaderboard-blur-bar" /> : user.name}
              </div>
              <div className={`leaderboard-xp${!user.blurred ? ' current' : ''}`}>
                {user.blurred ? <div className="leaderboard-blur-xp" /> : `${user.xp} XP`}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="right-elements-componentsmenu">
        <GetProCard />
       <MotivationalClasament />
          <FooterElements />
      <SocialElements />
      </div>
    </div>
  );
}
